import template from './teams-show.html'
export default {
	controller,
	controllerAs: 'vm',
	template,
}

/* @ngInject */
function controller($mdDialog, $log, team) {
	var vm = this
	vm.$onInit = () => {
		//API methods
		vm.cancel = cancel

		//Scope attributes
		vm.team = team

		activate()
		function activate() {}

		function cancel() {
			close()
		}

		function close() {
			$mdDialog.cancel()
		}
	}
}
